import { PairedCostVersion, expected } from '@aloft/toolkit-shared';
import { TypographyVariant } from '@aloft/toolkit-sui';

import { Flex } from '../../summary/components/Flex.tsx';
import { Typography } from '../../summary/components/Typography.tsx';
import { WebOnly } from '../../summary/components/WebOnly.tsx';
import { AddToExportSwitch } from './AddToExportSwitch.js';

export const TitleAndExportToggleLockup = ({
  title,
  commentary,
  id,
  pairedCostVersion,
  variant = 'h3',
}: {
  title: string;
  commentary?: { omitFromExport?: boolean; toggleOmitFromExport: (val: boolean) => void };
  id: string;
  pairedCostVersion?: PairedCostVersion;
  variant?: TypographyVariant;
}) => {
  return (
    <Flex width="100%" justifyContent="space-between">
      <Typography variant={variant}>{title}</Typography>
      {pairedCostVersion === 'legacy' && (
        <WebOnly>
          <Flex flexGrow={0}>
            <AddToExportSwitch
              id={id}
              value={expected(commentary).omitFromExport ?? false}
              setValue={expected(commentary).toggleOmitFromExport}
            />
          </Flex>
        </WebOnly>
      )}
    </Flex>
  );
};
